'use client'

import { useCompanyContext } from '@/lib/providers/CompanyProvider'
import { addRGBToHex } from '@/lib/utils/script'
import { useMemo } from 'react'

const CustomStyles = () => {
  const { main_color: primaryNormal, company_favicon, company_og, name } = useCompanyContext()

  const { primaryStrong, primaryHeavy } = useMemo(() => {
    return {
      primaryStrong: primaryNormal ? addRGBToHex(primaryNormal, 0, -8, -20) : '#005eeb',
      primaryHeavy: primaryNormal ? addRGBToHex(primaryNormal, 0, -18, -46) : '#0054d1',
    }
  }, [primaryNormal])

  return (
    <>
      {primaryNormal && (
        <>
          <style>
            {`:root {
        --Primary-Normal: ${primaryNormal};
        --Primary-Normal-10: ${primaryNormal}1A;
        --Primary-Normal-20: ${primaryNormal}33;
        --Primary-Normal-30: ${primaryNormal}4D;
        --Primary-Normal-40: ${primaryNormal}66;
        --Primary-Normal-50: ${primaryNormal}80;
        --Primary-Normal-60: ${primaryNormal}99;
        --Primary-Normal-70: ${primaryNormal}B3;
        --Primary-Normal-80: ${primaryNormal}CC;
        --Primary-Normal-90: ${primaryNormal}E5;
        --Primary-Normal-100: ${primaryNormal}FF;

        --Primary-Strong: ${primaryStrong};
        --Primary-Heavy: ${primaryHeavy};
      }`}
          </style>
        </>
      )}
    </>
  )
}

export default CustomStyles
